import React from 'react';
import { Card, Typography, Box } from "@curves/ui-base";

const TermContent = props => {
	const { className, sourceData, title, subheader, describe = '', children = null } = props;

	return (
		<Card className={className}>
			<Card.CardHeader title={title} subheader={subheader} className="bg-light-active text-center" />
			<Card.CardContent className="p-4">
				{describe && (
					<Typography variant="h5" component="div" className="pl-2 mb-2">
						{describe}
					</Typography>
				)}
				{Array.isArray(sourceData) && (
					<Box component="ol" className="lists ol mb-3">
						{sourceData.map((text, i) => (
							<Box component="li" key={i} className="lists-item">
								{text}
							</Box>
						))}
					</Box>
				)}
				{children}
			</Card.CardContent>
		</Card>
	);
};

export default TermContent;
